import { Interpolation } from "@emotion/core";
import { grid } from "../../../../../design-tokens/grid";
import { Fonts } from "../../../../../design-tokens/fonts";

const content: Interpolation = {
  marginTop: grid(3),
};

const detail: Interpolation = {
  display: "flex",
  justifyContent: "space-between",
  fontSize: "14px",
  lineHeight: grid(2),
  marginTop: grid(1),

  "> span": {
    fontWeight: Fonts.Weight.Bold,
  },
};

const styles = {
  content,
  detail,
};

export default styles;
